import { AppointmentRequest, ContactRequest } from '../data/siteContent';

type FormType = 'contact' | 'appointment' | 'rfp' | 'calculator';
type FormPayload = ContactRequest | AppointmentRequest | Record<string, unknown>;

interface Web3FormsResponse {
  success?: boolean;
  message?: string;
  body?: {
    message?: string;
  };
}

const endpoint = 'https://api.web3forms.com/submit';

export function getWeb3FormsAccessKey(): string {
  return (
    process.env.REACT_APP_WEB3FORMS_ACCESS_KEY ||
    process.env.REACT_APP_WEB3FORMS_KEY ||
    process.env.VITE_WEB3FORMS_ACCESS_KEY ||
    process.env.WEB3FORMS_ACCESS_KEY ||
    ''
  ).trim();
}

export function hasWeb3FormsAccessKey(): boolean {
  return getWeb3FormsAccessKey().length > 0;
}

export async function submitWeb3Form(
  formType: FormType,
  payload: FormPayload,
): Promise<void> {
  const accessKey = getWeb3FormsAccessKey();
  
  if (!accessKey) {
    console.warn(
      '⚠️ Web3Forms Warning: REACT_APP_WEB3FORMS_ACCESS_KEY is missing in Vercel Environment Variables. Submission simulated successfully for dev mode.'
    );
    return;
  }

  // Build a native FormData object to prevent CORS preflight issues on Vercel
  const formData = new FormData();
  formData.append('access_key', accessKey);
  formData.append(
    'from_name',
    `${(payload as Record<string, string>).fullName || 'Visitor'} via Technook Website`
  );
  formData.append(
    'subject',
    (payload as Record<string, string>).subject || `New Technook ${formType.toUpperCase()} Submission`
  );
  formData.append('form_type', formType);

  // Append all payload fields to FormData
  Object.entries(payload).forEach(([key, val]) => {
    if (val !== undefined && val !== null) {
      formData.append(key, typeof val === 'object' ? JSON.stringify(val) : String(val));
    }
  });

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: formData,
  });

  let result: Web3FormsResponse = {};
  try {
    result = (await response.json()) as Web3FormsResponse;
  } catch {
    // Non-JSON response fallback handled below
  }

  if (!response.ok || result.success !== true) {
    throw new Error(
      result.message ??
        result.body?.message ??
        `Web3Forms request failed with status ${response.status}.`
    );
  }
}
